module.exports = __webpack_public_path__ + "static/media/why-you-should-update-your-website-regularly.2cc1f67d.svg";